import { Injectable, InjectionToken } from '@angular/core';
import { EventBus } from '../event-bus';

export const TEAM_EVENT_BUS = new InjectionToken<TeamEventBus>('TeamEventBus', {
  providedIn: 'root',
  factory: () => new TeamEventBus(),
});

type ExternalEvents = '[Teams] updated' | '[Team] selected' | '[Team] created';

/**
 * TeamEventBus is responsible for emitting and listening to team-related events across the application.
 * Provided on demand by the team provider.
 */
@Injectable()
export class TeamEventBus extends EventBus<ExternalEvents> {}
